import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import isBetween from "dayjs/plugin/isBetween"
import { useTranslation } from "react-i18next"
import { DatePicker, Typography, Flex } from "antd"
import styles from "./ExperienceBooking.module.css"

dayjs.extend(isBetween)

const { Text } = Typography

const DateSelector = ({ value, onChange, activeTab, error, trip }) => {
  const [t] = useTranslation()
  const [open, setOpen] = useState(false)
  const disabledDate = useCallback(
    (current) => {
      const today = dayjs().startOf("day")
      const date = dayjs(current)
      const scheduledDeletionDate = trip?.guide?.scheduled_deletion_date

      if (!current || !trip) return true

      const weekdayMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
      }

      const blockedWeekdays = trip?.unavailable_weekdays?.map((day) => weekdayMap[day.toLowerCase()]) || []

      const isSoldOut = trip?.sold_out_dates?.some((dateStr) => date.isSame(dayjs(dateStr), "day"))
      const isUnavailable = trip?.unavailable_dates?.some((dateStr) => date.isSame(dayjs(dateStr), "day"))

      const hasDateRanges = Array.isArray(trip?.available_date_ranges) && trip.available_date_ranges.length > 0

      let isInAvailableRange = true
      if (hasDateRanges) {
        isInAvailableRange = trip.available_date_ranges.some((range) => {
          const start = dayjs(range.start).startOf("day")
          const end = dayjs(range.end).endOf("day")
          return date.isBetween(start, end, null, "[]")
        })
      }

      return (
        date.isBefore(today) ||
        date.isAfter(scheduledDeletionDate) ||
        blockedWeekdays.includes(date.day()) ||
        isUnavailable ||
        isSoldOut ||
        (hasDateRanges && !isInAvailableRange)
      )
    },
    [trip]
  )

  return (
    <div className={styles.guestsWrapper}>
      <Flex
        className={`${styles.inputContainer} ${open ? styles.activeBorder : ""} ${error ? styles.errorBorder : ""}`}
        onClick={() => {
          if (activeTab !== 2 && activeTab !== 3 && !open) {
            setOpen(true)
          }
        }}
      >
        <span className={styles.inputLabel}>Date</span>
        <DatePicker
          value={value}
          disabled={activeTab === 2 || activeTab === 3}
          onChange={onChange}
          placeholder="Select Date"
          format="MM/DD/YY"
          suffixIcon={null}
          disabledDate={disabledDate}
          className={styles.datePickerStyled}
          allowClear={false}
          bordered={false}
          open={open}
          onOpenChange={setOpen}
          popupClassName={styles.dateDropdownPanel}
        />
      </Flex>

      {error && <Text style={{ color: "red" }}>{t("webIntegration.embedded_validation.date")}</Text>}
    </div>
  )
}

DateSelector.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  activeTab: PropTypes.number,
  error: PropTypes.bool,
  trip: PropTypes.object
}

export default React.memo(DateSelector)
